import React, { useState, useEffect } from 'react';
import { colors } from '../styles/colors';
import { fonts, fontWeights } from '../styles/fonts';
import { content } from '../constants/content';

function Team() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section id="team" style={isMobile ? styles.sectionMobile : styles.section}>
      <h2 style={isMobile ? styles.titleMobile : styles.title}>
        {content.team.title}
      </h2>
      
      <div style={isMobile ? styles.gridMobile : styles.grid}>
        {content.team.members.map((member, index) => (
          <div key={index} style={isMobile ? styles.cardMobile : styles.card}>
            <h3 style={isMobile ? styles.nameMobile : styles.name}>
              {member.name}
            </h3>
            <p style={isMobile ? styles.positionMobile : styles.position}>
              {member.title}
            </p>
            <a href={`mailto:${member.email}`} style={isMobile ? styles.emailMobile : styles.email}>
              {member.email}
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}

const styles = {
  section: {
    padding: '80px 60px',
    backgroundColor: colors.white,
    textAlign: 'center',
  },
  sectionMobile: {
    padding: '40px 20px',
    backgroundColor: colors.white,
    textAlign: 'center',
  },
  title: {
    fontSize: '48px',
    fontWeight: fontWeights.bold,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
    marginBottom: '60px',
  },
  titleMobile: {
    fontSize: '32px',
    fontWeight: fontWeights.bold,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
    marginBottom: '40px',
    lineHeight: '1.2',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '30px',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  gridMobile: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    maxWidth: '100%',
    margin: '0 auto',
  },
  card: {
    padding: '40px 30px',
    backgroundColor: colors.white,
    border: `2px solid ${colors.primary}`,
    borderRadius: '12px',
    textAlign: 'center',
  },
  cardMobile: {
    padding: '30px 20px',
    backgroundColor: colors.white,
    border: `2px solid ${colors.primary}`,
    borderRadius: '12px',
    textAlign: 'center',
    width: '100%',
  },
  name: {
    fontSize: '24px',
    fontWeight: fontWeights.bold,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
    marginBottom: '10px',
  },
  nameMobile: {
    fontSize: '22px',
    fontWeight: fontWeights.bold,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
    marginBottom: '8px',
  },
  position: {
    fontSize: '16px',
    fontWeight: fontWeights.regular,
    fontFamily: fonts.primary,
    color: colors.textSecondary,
    marginBottom: '15px',
  },
  positionMobile: {
    fontSize: '15px',
    fontWeight: fontWeights.regular,
    fontFamily: fonts.primary,
    color: colors.textSecondary,
    marginBottom: '12px',
  },
  email: {
    fontSize: '16px',
    fontWeight: fontWeights.regular,
    fontFamily: fonts.primary,
    color: colors.primary,
    textDecoration: 'none',
  },
  emailMobile: {
    fontSize: '15px',
    fontWeight: fontWeights.regular,
    fontFamily: fonts.primary,
    color: colors.primary,
    textDecoration: 'none',
    wordBreak: 'break-word',
  },
};

export default Team;